import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api`;
const url_main = `${process.env.REACT_APP_API_URL_RESOURCE}/api/main`;
let _successCallback = function (response: any) {
  if (
    typeof response.data !== 'undefined' &&
    !!('result' in response.data) &&
    parseInt(response.data.result) === 1
  ) {
    return response.data.data || response.data.result;
  } else {
    throw !!('result' in response.data) ? response.data : false;
  }
};
let _errorCallback = function (error: any) {
  if (error !== false && ['object', 'array'].indexOf(typeof error) > -1 && !!('result' in error)) {
    if ([20, 22, 23, 24].indexOf(error.result) > -1) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('merchant_id');
    }
  } else {
    console.error(error);
  }
};
const uploadOSS = function (_permit: any, file: any) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', function (e) {
      if (e.lengthComputable) {
        //        console.log(e.loaded / e.total);
      }
    });
    xhr.upload.addEventListener('load', function () {
      //      console.log("uploaded");
    });
    xhr.onreadystatechange = function () {
      // Call a function when the state changes.
      if (this.readyState === XMLHttpRequest.DONE) {
        const ret: any = { code: this.status };
        if (this.status === 200) {
          ret.data = xhr.response;
          resolve(ret);
        } else {
          reject(ret);
        }
      }
    };
    xhr.open('PUT', _permit.sign_url);
    xhr.setRequestHeader('x-oss-callback', _permit['x-oss-callback']);
    xhr.overrideMimeType(file.type);
    xhr.setRequestHeader('Content-Type', '');
    xhr.responseType = 'json';
    xhr.send(file);
  })
    .then(_successCallback)
    .catch(_errorCallback);
};
function getUploadPermit(i_controller: any, i_action: any, i_fileMeta: any, i_formData = {}) {
  var meta = {
    lastModified: i_fileMeta.lastModified,
    lastModifiedDate: i_fileMeta.lastModifiedDate,
    name: i_fileMeta.name,
    size: i_fileMeta.size,
    type: i_fileMeta.type
  };
  const formData = Object.assign({}, { meta: meta }, i_formData);
  return client.post({
    url: `${url}/upload/token/${i_controller}/${i_action}`,
    form: formData
  });
}
export async function uploadFile(_permit: any, file: any) {
  return uploadOSS(_permit, file);
}
export async function getResourcePermit(i_fileMeta: any, i_formData: any) {
  return getUploadPermit('resource', 'course', i_fileMeta, i_formData);
}
// 获取校本课程id
export async function getSchoolCourseID(id = 'school_resource') {
  return client.post({
    url: `${url}/course/get`,
    form: {
      id
    }
  });
}
// 校本资料上传图片 (封面)
export async function getSchoolResourcePermit(i_fileMeta: any, i_formData: any) {
  return getUploadPermit('school_resource', 'cover', i_fileMeta, i_formData);
}
// 校本课程更改封面背景上传-文件夹
export async function uploadBgFile(id: any, bg_id: any) {
  return client.post({
    url: `${url}/course/update_bg`,
    form: {
      id,
      bg_id
    }
  });
}

// 校本课程更改封面背景上传
export async function uploadBgFileMain(id: any, bg_id: any) {
  return client.post({
    url: `${url_main}/update_bg`,
    form: {
      id,
      bg_id
    }
  });
}

// 探索小任务语音评优上传
export async function getUserRecordCommentVoicePermit(i_fileMeta: any, i_formData: any) {
  return getUploadPermit('user_record_comment', 'voice', i_fileMeta, i_formData);
}
export async function getUserRecordCommentFilePermit(i_fileMeta: any, i_formData: any) {
  return getUploadPermit('user_record_comment', 'file', i_fileMeta, i_formData);
}
// 删除文件
export async function deleteCommentFile(id: string, action: string) {
  return client.post({
    url: `${url}/user_record_comment/delete_file`,
    form: {
      ur_id: id,
      action
    }
  });
}

const typeConfig: any = {
  project: 'user_record_comment',
  jttw360: 'jttw_user_record_comment'
};
// 探索小任务二级列表打开弹窗编辑提交
export async function addComment(form: any) {
  const { type = 'project', ...rest } = form;
  return client.post({
    url: `${url}/${typeConfig[type]}/add`,
    form: {
      ...rest,
      app_type: 'KID_WEB'
    }
  });
}
// 探索小任务二级列表编辑
export async function addCommentForEditable(formData: any) {
  return client.post({
    url: `${url}/user_record_comment/add`,
    form: {
      ...formData,
      app_type: 'KID_WEB'
    }
  });
}
// 探索小任务批量修改
export async function batchUpdate(form: any) {
  return client.post({
    url: `${url}/user_record_comment/batch_update`,
    form
  });
}
// 获取课程信息
export async function getInfo(urlId: string) {
  return client.post({
    url: `${url}/course/get`,
    form: {
      id: urlId
    }
  });
}
// 获取课件详细的内容
export async function getCoureDetail(i_refID: string) {
  const data = await client.post({
    url: `${url_main}/get`,
    form: {
      id: i_refID
    }
  });
  return data;
}
// 获取当前校本资源的显示信息(不包含修改功能)
export async function getFullDisplayInfo(id: string) {
  return client.post({
    url: `${url_main}/get_full_display_info `,
    form: {
      id
    }
  });
}
// 获取mc课件信息
export async function getFullInfo(id: string) {
  return client.post({
    url: `${url_main}/get_full_info`,
    form: {
      id
    }
  });
}
// 校本课件project类型上传文件
export async function getUserRecordAddPermit(i_fileMeta: any, i_formData: any) {
  return getUploadPermit('user_record', 'add', i_fileMeta, i_formData);
}

export async function getUserRecordUpdatePermit(i_fileMeta: any, i_formData: any) {
  return getUploadPermit('user_record', 'update', i_fileMeta, i_formData);
}

// 獲取即時發佈狀態
export async function getUserRecordSetting(course_id: string, res_id: string) {
  return client.post({
    url: `${url}/user_record_setting/get`,
    form: {
      course_id,
      res_id
    }
  });
}
// 設置即時發佈狀態
export async function setUserRecordSetting(
  course_id: string,
  res_id: string,
  is_show_comment: string
) {
  return client.post({
    url: `${url}/user_record_setting/add`,
    form: {
      course_id,
      res_id,
      is_show_comment
    }
  });
}

//新增課程子分類頁面數據
export async function search({
  tag = null,
  keyword = '',
  grade = [],
  type = [],
  offset = 0,
  limit = 5,
  show_total = true,
  school_only = false,
  evi_only = false,
  lang,
  vo_lang,
  sort,
  order
}: any) {
  let _type = [].concat(
    ...type.map((_item: any) => {
      return _item.split(',');
    })
  );
  return client
    .post({
      url: `${url}/search`,
      form: {
        tag: tag,
        keyword: keyword || '',
        grade: grade.join(','),
        type: _type,
        offset: offset * limit,
        limit: limit,
        school_only: !!school_only ? 'Y' : 'N',
        evi_only: !!evi_only ? 'Y' : 'N',
        lang,
        vo_lang,
        sort,
        order
      }
    })
    .then((ret: any) => {
      return !!show_total ? ret : ret.rows;
    })
    .catch((err: any) => {
      return !!show_total ? { total: 0, rows: [] } : [];
    });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  uploadBgFile,
  uploadFile,
  getResourcePermit,
  getSchoolCourseID,
  getSchoolResourcePermit,
  getUserRecordCommentVoicePermit,
  getUserRecordCommentFilePermit,
  deleteCommentFile,
  addComment,
  addCommentForEditable,
  batchUpdate,
  getInfo,
  getCoureDetail,
  getFullInfo,
  getFullDisplayInfo,
  getUserRecordAddPermit,
  getUserRecordUpdatePermit,
  getUserRecordSetting,
  setUserRecordSetting,
  search
};
